<template>

  <div id="app_content" class="admin admin-downloads">

    <!-- <cataloghi /> -->

    <downloads />

  </div>

</template>

<script>
import cataloghi from './cataloghi.vue'
import downloads from './downloads.vue'

export default {

  components: {cataloghi, downloads},

  data() {
    return {

    }
  }
  
}
</script>

<style lang="scss" scoped>

</style>
